var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5a7.5 7.5 0 010 15H9a7.5 7.5 0 010-15h6zM8.235 6.586v1.406h5.523L9.502 17.25h1.86l4.264-9.697v-.967h-7.39z",
    fill: "currentColor"
  })));
}
SvgPokerSeats7.displayName = 'PokerSeats7';
export default SvgPokerSeats7;